import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import moment from 'moment';
// @mui
import {
  Card,
  Table,
  Stack,
  Button,
  Box,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TextField,
  Modal,
  TablePagination,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from '@mui/material';
import Scrollbar from '../components/scrollbar';
import { UserListHead } from '../sections/@dashboard/user';
import Services from 'src/services/Services';
import CircularProgress from '@mui/material/CircularProgress';
import Iconify from '../components/iconify';
import { toast } from 'react-toastify';
import { tokenService } from 'src/services';
// ----------------------------------------------------------------------

const REQUESTS_TABLE_HEAD = [
  { id: 'no', label: 'No', alignRight: false },
  { id: 'name', label: 'Ad Soyad', alignRight: false },
  { id: 'phone', label: 'Telefon', alignRight: false },
  { id: 'date', label: 'Tarih', alignRight: false },
  { id: 'state', label: 'Durum', alignRight: false },
  { id: '', label: 'İşlemler' },
];

const OPERATIONS_TABLE_HEAD = [
  { id: 'no', label: 'No', alignRight: false },
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: 'Ad Soyad', alignRight: false },
  { id: 'phone', label: 'Telefon', alignRight: false },
  { id: 'date', label: 'Tarih', alignRight: false },
  { id: 'state', label: 'Durum', alignRight: false },
];

const COMPLETED_TABLE_HEAD = [
  { id: 'no', label: 'No', alignRight: false },
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: 'Ad Soyad', alignRight: false },
  { id: 'date', label: 'Tarih', alignRight: false },
];

export default function HandsfreePage() {
  const [locationID, setLocationID] = useState('');
  const [token, setToken] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedTab, setSelectedTab] = useState('talepleri');
  const [countModal, setCountModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [count, setCount] = useState('');
  const [selectedOrderID, setSelectedOrderID] = useState('');
  const [requests, setRequests] = useState([]);
  const [operations, setOperations] = useState([]);
  const [completeds, setCompleteds] = useState([]);
  const [success, setSuccess] = useState(false);
  const [rejectedSuccess, setRejectedSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showType, setShowType] = useState('all');
  const [onlyWaitingDatas, setOnlyWaitingDatas] = useState([]);
  const [allRequests, setAllRequests] = useState([]);
  const [orderNumbers, setOrderNumbers] = useState();
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isCheckboxChecked2, setIsCheckboxChecked2] = useState(false);
  const [note, setNote] = useState('');
  const [userNote, setUserNote] = useState('');
  const [isHotel, setIsHotel] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    phone: '',
    inventory: 0,
    email: '',
    note: '',
    deliveryType: '',
  });
  const [deliveryPassword, setDeliveryPassword] = useState('');
  const [successCreated, setSuccessCreated] = useState(false);
  const [storeOrderNumbers, setStoreOrderNumbers] = useState();
  const [notForStore, setNotForStore] = useState('');
  const datas = JSON.parse(localStorage.getItem('user'));
  const [deliveryTypes, setDeliveryTypes] = useState([]);

  const [predefinedTypes, setPredefinedTypes] = useState([]);
  const [selectedAddressType, setSelectedAddressType] = useState('');
  const [selectedPredefined, setSelectedPredefined] = useState('');
  const [hotelRoom, setHotelRoom] = useState('');
  const [pointsTypes, setPointsTypes] = useState([]);
  const [selectedPointType, setSelectedPointType] = useState('');
  const [selectedSubValue, setSelectedSubValue] = useState('');
  const [townList, setTownList] = useState([]);
  const [selectedTown, setSelectedTown] = useState('');
  const [districtList, setDistrictList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [lockBoxList, setLockBoxList] = useState([]);
  const [selectedLockBox, setSelectedLockBox] = useState('');
  const [fullAddress, setFullAddress] = useState('');
  const [addressDescription, setAddressDescription] = useState('');
  const [mall, setMall] = useState();

  function extractUniqueTypes(dataArray) {
    const types = new Set(); // Tekrar eden typeları önlemek için Set kullanıyoruz

    dataArray?.forEach((item) => {
      if (item.type) {
        types.add(item.type); // type varsa Set'e ekle
      }
    });

    return Array.from(types); // Set'i array'e dönüştürüyoruz
  }

  const extractTowns = (obj) => {
    if (obj) {
      return Object.keys(obj).map((town) => town);
    }
  };

  function checkDataAvailability(data) {
    const result = {};

    let deliveryTypesArr = [];
    let predefinedTypesArr = extractUniqueTypes(data?.predefined);
    let pointsTypesArr = extractUniqueTypes(data?.points);
    let townListArr = extractTowns(data?.localDelivery);
    let lockBoxListArr = data.postbox;
    // Genel kontrol fonksiyonu: değer var mı ve null, false veya boş değil mi?
    const isValid = (value) =>
      value !== null &&
      value !== false &&
      value !== undefined &&
      (Array.isArray(value)
        ? value?.length > 0
        : Object.keys(value || {})?.length > 0);

    // Points kontrolü
    if (isValid(data.points)) {
      result.points = 'Points mevcut ve geçerli.';
      deliveryTypesArr.push({ type: 'points', title: 'Easy Point' });
    }

    // Predefined kontrolü
    if (isValid(data.predefined) || isValid(data.localDelivery)) {
      result.predefined = 'Predefined mevcut ve geçerli.';
      deliveryTypesArr.push({
        type: 'address',
        title: 'Adrese Teslim',
      });
    }

    // Postbox kontrolü
    if (isValid(data.postbox)) {
      result.postbox = 'Postbox mevcut ve geçerli.';
      deliveryTypesArr.push({
        type: 'postbox',
        title: 'Dolaba Teslim',
      });
    }

    // LocalDelivery kontrolü
    if (isValid(data.localDelivery)) {
      result.localDelivery = 'LocalDelivery mevcut ve geçerli.';
    }

    if (townListArr?.length === 1) {
      setSelectedTown(townListArr[0]);
    }

    setLockBoxList(lockBoxListArr);
    setTownList(townListArr);
    setPointsTypes(pointsTypesArr);
    setPredefinedTypes(predefinedTypesArr);
    setDeliveryTypes(deliveryTypesArr);
  }

  const createHandsfreeByStore = () => {
    // userID de gönderilecek
    const createdBy = tokenService.getUser()?.userID;
    setLoading(true);
    if (
      formData.name === '' ||
      formData.lastname === '' ||
      (formData.phone === '' && formData.email === '') ||
      formData.inventory <= 0 ||
      formData.inventory === null ||
      formData.inventory === undefined ||
      formData.inventory === NaN
    ) {
      toast.error('Zorunlu alanları doldurunuz.');
      setLoading(false);
    } else {
      let deliveryTypeInfo = {};

      if (selectedSubValue) {
        deliveryTypeInfo = {
          deliveryType: formData.deliveryType,
          type: selectedSubValue.type,
          id: selectedSubValue.id,
          text: selectedSubValue.title,
          additionalNote: addressDescription,
          price: selectedSubValue.price,
          currency: selectedSubValue.currency,
        };
      } else if (selectedPredefined) {
        deliveryTypeInfo = {
          deliveryType: formData.deliveryType,
          type: 'predefined',
          text: selectedPredefined.title,
          additionalNote: '(Oda No: ' + hotelRoom + ') ' + addressDescription,
          price: selectedPredefined.price,
          currency: selectedPredefined.currency,
        };
      } else if (selectedTown) {
        deliveryTypeInfo = {
          deliveryType: formData.deliveryType,
          type: 'custom',
          text: selectedTown + ' ' + selectedDistrict + ' ' + fullAddress,
          additionalNote: addressDescription,
          price: mall.deliveryTypes.localDelivery[selectedTown].price,
          currency: mall.deliveryTypes.localDelivery[selectedTown].currency,
        };
      } else if (selectedLockBox) {
        deliveryTypeInfo = {
          deliveryType: formData.deliveryType,
          locationCode: selectedLockBox.locationCode,
          text: selectedLockBox.title,
          additionalNote: addressDescription,
          price: selectedLockBox.price,
          currency: selectedLockBox.currency,
          id: selectedLockBox.id,
        };
      }

      const additionalNote = `Teslim alacak kişi: ${formData.name} ${formData.lastname} Not: ${formData.note}`;
      console.log('test: ', {
        locationID,
        formData,
        additionalNote,
        createdBy,
        deliveryTypeInfo,
      });
      setNotForStore(additionalNote);
      Services.CreateHandsfreeByStore(
        token,
        locationID,
        formData,
        additionalNote,
        createdBy,
        deliveryTypeInfo
      )
        .then((res) => {
          console.log('create handsfree: ', res.data);
          if (res.data.status) {
            toast.success(
              `${
                tokenService.getUser()?.authLocations?.branch[0]?.mallID ===
                '98569271082166328155'
                  ? 'Bags-Free'
                  : 'Hands Free'
              } Gönderisi başarıyla oluşturuldu.`
            );
            setDeliveryPassword(res.data.result.deliveryPassword);
            setStoreOrderNumbers(res.data.result.orderNumbers);
            setCreateModal(false);
            setSuccessCreated(true);
          } else {
            toast.error(
              `${
                tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
                '98569271082166328155'
                  ? 'Bags-Free'
                  : 'Hands Free'
              } gönderisi oluşturulurken hata oluştu`
            );
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(
            `${
              tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
              '98569271082166328155'
                ? 'Bags-Free'
                : 'Hands Free'
            } gönderisi oluşturulurken hata oluştu`
          );
        })
        .finally(() => setLoading(false));
    }
  };

  const handleSuccess = (type) => {
    if (type === 'confirm') {
      setSuccess(true);
    } else {
      setRejectedSuccess(true);
    }
    setLoading(false);
  };

  const handleFailed = () => {
    setFailed(true);
    setLoading(false);
  };

  const handleCloseCountModal = () => {
    if (loading) {
      return;
    } else {
      setCountModal(false);
      setSelectedOrderID('');
      setCount('');
      setNote('');
    }
  };
  const handleCloseCreateModal = () => {
    if (loading) {
      return;
    } else {
      setCreateModal(false);
      setFormData({
        name: '',
        lastname: '',
        phone: '',
        email: '',
        inventory: 0,
        note: '',
      });
    }
  };

  const confirmRequest = () => {
    if (count === null || +count <= 0) {
      toast.error('Lütfen paket sayısını doğru giriniz.');
    } else {
      // console.log(selectedOrderID, count);
      setLoading(true);
      Services.GetHandsFreeConfirm(token, selectedOrderID, +count)
        .then((res) => {
          console.log('confirm response: ', res.data);
          setOrderNumbers(res.data.result);
          handleSuccess('confirm');
          setCountModal(false);
          setSelectedOrderID('');
          setCount('');
        })
        .catch((err) => {
          // console.log(err);
          // console.log('Bir hata oluştu');
          handleFailed();
        });
    }
  };

  const rejectRequest = () => {
    // console.log(selectedOrderID, token);
    Services.GetHandsFreeReject(token, selectedOrderID)
      .then((res) => {
        // console.log(res.data);
        handleSuccess('reject');
        setRejectModal(false);
        setSelectedOrderID('');
      })
      .catch((err) => {
        // console.log(err);
        // console.log('Bir hata oluştu');
        handleFailed();
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const processedValue = name === 'inventory' ? parseInt(value, 10) : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: processedValue,
    }));

    if (name === 'deliveryType') {
      setSelectedAddressType('');
      setSelectedPredefined('');
      setSelectedPointType('');
      setSelectedSubValue('');
      setSelectedTown('');
      setSelectedLockBox('');
      setSelectedDistrict('');
      setFullAddress('');
      setAddressDescription('');
    }
  };

  const handlePointTypeChange = (event) => {
    setSelectedPointType(event.target.value);
    setSelectedSubValue('');
  };

  const handlePredefinedTypeChange = (event) => {
    setSelectedAddressType(event.target.value);
    setSelectedPredefined('');
    setSelectedTown('');
    setHotelRoom('');
    setSelectedDistrict('');
    setFullAddress('');
    setAddressDescription('');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const isButtonDisabled = () => {
    if (!formData.deliveryType) return true;

    if (formData.deliveryType === 'points') {
      return !selectedPointType || !selectedSubValue;
    }

    if (formData.deliveryType === 'address') {
      if (!selectedAddressType) return true;

      if (selectedAddressType === 'address') {
        return !selectedTown || !selectedDistrict || !fullAddress;
      }
      if (selectedAddressType === 'predefined') {
        return (
          !selectedPredefined ||
          (selectedPredefined.type === 'hotel' && !hotelRoom)
        );
      }
    }

    if (formData.deliveryType === 'postbox') {
      return !selectedLockBox;
    }

    return false;
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - req?.length) : 0;

  const findLocation = (handsfreeToken, branch, token) => {
    // console.log(token, branch);
    Services.GetLocation(token, branch)
      .then((res) => {
        // console.log('location response: ', res.data);
        setLocationID(res?.data?.result[0]?.locationID);
        Services.GetHandsFreeOrders(
          handsfreeToken,
          res.data.result?.map((x) => x.locationID)
        )
          .then((response) => {
            console.log('handsfreeOrders: ', response.data);
            const allRequests = response.data.result;
            // Tamamı
            const sortedRequests = allRequests?.sort(
              (a, b) => b.createdDateTime - a.createdDateTime
            );
            setAllRequests(sortedRequests);
            setRequests(sortedRequests);
            // Sadece Bekleyenler
            const onlyWaitingDatas = allRequests?.filter(
              (item) => item.status === '3'
            );
            const sortedWaitingDatas = onlyWaitingDatas?.sort(
              (a, b) => b.createdDateTime - a.createdDateTime
            );
            setOnlyWaitingDatas(sortedWaitingDatas);
          })
          .catch((error) => {
            // console.log('Orders error: ', error);
            setRequests([]);
          });
      })
      .catch((err) => {
        // console.log('locations error: ', err);
      });
  };

  const fetchDatas = () => {
    Services.GetToken()
      .then((response) => {
        console.log('datas: ', datas);
        setToken(response.data.result.token);
        findLocation(response.data.result.token, datas.branchID, datas.token);
        Services.GetMallsForHandsfree(response.data.result.token)
          .then((res) => {
            const mallID = datas?.authLocations?.branch[0]?.mallID;
            const matchedMall = res.data.result.find(
              (mall) => mall.id === mallID
            );

            setMall(matchedMall);

            if (matchedMall) {
              checkDataAvailability(matchedMall.deliveryTypes);
            } else {
              console.log('Eşleşen mall bulunamadı.');
            }
          })
          .catch((err) => console.log(err));
        Services.GetHandsFreePosts(
          response.data.result.token,
          datas.branchID,
          [1, 2, 3, 4, 5, 6]
        )
          .then((res) => {
            // console.log(res.data);
            const sortedOperations = res.data.result.sort(
              (a, b) => b.createdDateTime - a.createdDateTime
            );
            setOperations(sortedOperations);
          })
          .catch((err) => {
            // console.log(err);
            setOperations([]);
          });

        Services.GetHandsFreePosts(response.data.result.token, datas.branchID, [
          1,
        ])
          .then((res) => {
            // console.log(res.data);
            const sortedPosts = res.data.result.sort(
              (a, b) => b.createdDateTime - a.createdDateTime
            );
            setCompleteds(sortedPosts);
          })
          .catch((err) => {
            // console.log(err);
            setCompleteds([]);
          });
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchDatas();
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    fetchDatas();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {' '}
          {tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
          '98569271082166328155'
            ? 'Bags-Free'
            : 'Hands Free'}{' '}
          | Minimal UI{' '}
        </title>
      </Helmet>

      <Stack style={{ paddingInline: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h4" gutterBottom>
            {selectedTab === 'talepleri' &&
              `  ${
                tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
                '98569271082166328155'
                  ? 'Bags-Free'
                  : 'Hands Free'
              } Talepleri`}
            {selectedTab === 'islemleri' &&
              `  ${
                tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
                '98569271082166328155'
                  ? 'Bags-Free'
                  : 'Hands Free'
              } İşlemleri`}
            {selectedTab === 'tamamlanmis' &&
              `  ${
                tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
                '98569271082166328155'
                  ? 'Bags-Free'
                  : 'Hands Free'
              } Tamamlanmış İşler`}
          </Typography>

          <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={(event, newTab) => setSelectedTab(newTab)}
          >
            <ToggleButton value="talepleri">
              {tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
              '98569271082166328155'
                ? 'Bags-Free'
                : 'Hands Free'}{' '}
              Talepleri
            </ToggleButton>
            <ToggleButton value="islemleri">
              {tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
              '98569271082166328155'
                ? 'Bags-Free'
                : 'Hands Free'}{' '}
              İşlemleri
            </ToggleButton>
            <ToggleButton value="tamamlanmis">
              {tokenService?.getUser()?.authLocations?.branch[0]?.mallID ===
              '98569271082166328155'
                ? 'Bags-Free'
                : 'Hands Free'}{' '}
              Tamamlanmış İşler
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>

        {datas?.canCreateHandsfreeOrder && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            my={2}
          >
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setCreateModal(true)}
            >
              Sipariş Oluştur
            </Button>
          </Stack>
        )}

        {onlyWaitingDatas?.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <Button
              onClick={() => {
                if (showType === 'all') {
                  setRequests(onlyWaitingDatas);
                  setShowType('onlyWaitings');
                } else {
                  setRequests(allRequests);
                  setShowType('all');
                }
              }}
              variant="contained"
              size="large"
            >
              {showType === 'all'
                ? `Onay Bekleyenleri Göster (${onlyWaitingDatas.length})`
                : `Tümünü Göster`}
            </Button>
          </div>
        )}

        <Card
          sx={{
            backgroundColor: 'white',
            paddingBottom: '30px',
          }}
        >
          <Scrollbar>
            <Box sx={{ width: '100%', paddingInline: '30px' }}>
              {/* Render content based on the selected tab */}
              {selectedTab === 'talepleri' && (
                <>
                  {requests?.length > 0 ? (
                    <div style={{ marginTop: 50 }}>
                      <Table>
                        <UserListHead
                          headLabel={REQUESTS_TABLE_HEAD}
                          rowCount={requests?.length}
                          onRequestSort={() => null}
                        />
                        <TableBody>
                          {requests
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => {
                              const {
                                orderID,
                                name,
                                lastname,
                                phone,
                                status,
                                inventoryCount,
                                createdDateTime,
                                additionalNote,
                                deliveryTypeInfo,
                              } = row;

                              return (
                                <TableRow hover key={index} tabIndex={-1}>
                                  <TableCell align="left">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="left">
                                    {name + ' ' + lastname?.length > 0
                                      ? lastname[0]
                                      : ''}
                                    .
                                  </TableCell>
                                  <TableCell align="left">{phone}</TableCell>

                                  <TableCell align="left">
                                    {moment
                                      .unix(createdDateTime)
                                      .format('DD/MM/YYYY HH:mm')}
                                  </TableCell>
                                  <TableCell align="left">
                                    {status === '1'
                                      ? 'Onaylandı'
                                      : status === '2'
                                      ? 'Reddedildi'
                                      : status === '3'
                                      ? 'Mağazadan Onay Bekliyor'
                                      : status === '6'
                                      ? 'Müşteriden Onay Bekleniyor'
                                      : status === '2' && inventoryCount === '0'
                                      ? 'Reddettiniz'
                                      : 'Bilinmiyor'}{' '}
                                    {+inventoryCount > 0 &&
                                      '(' + inventoryCount + ')'}
                                  </TableCell>
                                  <TableCell align="left">
                                    {status === '3' && (
                                      <div>
                                        <Button
                                          variant="contained"
                                          onClick={() => {
                                            setSelectedOrderID(orderID);
                                            setCountModal(true);
                                            setNote(additionalNote);
                                            setUserNote(
                                              deliveryTypeInfo?.additionalNote
                                            );
                                            deliveryTypeInfo?.predefinedType
                                              ? setIsHotel(true)
                                              : setIsHotel(false);
                                          }}
                                          sx={{ marginRight: '8px' }}
                                        >
                                          Onayla
                                        </Button>
                                        <Button
                                          onClick={() => {
                                            setSelectedOrderID(orderID);
                                            setRejectModal(true);
                                          }}
                                          variant="contained"
                                          color="error"
                                        >
                                          Reddet
                                        </Button>
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={requests?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  ) : (
                    <Typography mt={5} color={'gray'}>
                      {tokenService?.getUser()?.authLocations?.branch[0]
                        ?.mallID === '98569271082166328155'
                        ? 'Bags-Free'
                        : 'Hands Free'}{' '}
                      Talebi Bulunmamaktadır
                    </Typography>
                  )}{' '}
                </>
              )}

              {selectedTab === 'islemleri' && (
                <>
                  {operations?.length > 0 ? (
                    <div style={{ marginTop: 50 }}>
                      <Table>
                        <UserListHead
                          headLabel={OPERATIONS_TABLE_HEAD}
                          rowCount={operations?.length}
                          onRequestSort={() => null}
                        />
                        <TableBody>
                          {operations
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => {
                              const {
                                orderNumber,
                                name,
                                lastname,
                                phone,
                                createdDateTime,
                                status,
                              } = row;

                              return (
                                <TableRow hover key={index} tabIndex={-1}>
                                  <TableCell align="left">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="left">
                                    {orderNumber}
                                  </TableCell>
                                  <TableCell align="left">
                                    {' '}
                                    {name + ' ' + lastname}
                                  </TableCell>
                                  <TableCell align="left">{phone}</TableCell>
                                  <TableCell align="left">
                                    {' '}
                                    {moment
                                      .unix(createdDateTime)
                                      .format('DD/MM/YYYY HH:mm')}
                                  </TableCell>
                                  <TableCell align="left">
                                    {status === '1'
                                      ? 'Tamamlandı'
                                      : status === '2'
                                      ? 'İptal Edildi'
                                      : status === '3'
                                      ? 'Mağazada Bekliyor'
                                      : status === '4'
                                      ? 'Porter Taşımasında'
                                      : status === '5'
                                      ? 'Teslim Noktasında'
                                      : status === '6'
                                      ? 'Müşteri Onayı Bekliyor'
                                      : 'Bilinmiyor'}{' '}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={requests?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  ) : (
                    <Typography mt={5} color={'gray'}>
                      {tokenService?.getUser()?.authLocations?.branch[0]
                        ?.mallID === '98569271082166328155'
                        ? 'Bags-Free'
                        : 'Hands Free'}{' '}
                      İşlemleri Bulunmamaktadır
                    </Typography>
                  )}
                </>
              )}
              {selectedTab === 'tamamlanmis' && (
                <>
                  {completeds?.length > 0 ? (
                    <div style={{ marginTop: 50 }}>
                      <Table>
                        <UserListHead
                          headLabel={COMPLETED_TABLE_HEAD}
                          rowCount={completeds?.length}
                          onRequestSort={() => null}
                        />
                        <TableBody>
                          {completeds
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => {
                              const {
                                orderNumber,
                                name,
                                lastname,
                                createdDateTime,
                              } = row;

                              return (
                                <TableRow hover key={index} tabIndex={-1}>
                                  <TableCell align="left">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="left">
                                    {orderNumber}
                                  </TableCell>
                                  <TableCell align="left">
                                    {name + ' ' + lastname}
                                  </TableCell>
                                  <TableCell align="left">
                                    {moment
                                      .unix(createdDateTime)
                                      .format('DD/MM/YYYY HH:mm')}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={requests?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  ) : (
                    <Typography mt={5} color={'gray'}>
                      {tokenService?.getUser()?.authLocations?.branch[0]
                        ?.mallID === '98569271082166328155'
                        ? 'Bags-Free'
                        : 'Hands Free'}{' '}
                      Tamamlanmış İşleri Bulunmamaktadır
                    </Typography>
                  )}
                </>
              )}
            </Box>
          </Scrollbar>
        </Card>
        <Modal
          open={countModal}
          onClose={() => {
            handleCloseCountModal();
            // setCountModal(false);
            // setSelectedOrderID('');
            // setCount('');
            // setNote('');
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 400,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6">Paket Sayısı Giriniz</Typography>
            <TextField
              sx={{ marginBlock: '30px' }}
              fullWidth
              label="Paket Sayısı"
              variant="outlined"
              type="number"
              value={count}
              onChange={(e) => setCount(e.target.value)}
            />
            <Button
              onClick={() => {
                confirmRequest();
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Tamamla'
              )}
            </Button>
          </Box>
        </Modal>

        <Modal
          open={createModal}
          onClose={() => {
            if (loading) return;
            else handleCloseCreateModal();
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 400,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <TextField
              sx={{ marginBlock: '10px' }}
              fullWidth
              label="Ad*"
              variant="outlined"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <TextField
              sx={{ marginBlock: '10px' }}
              fullWidth
              label="Soyad*"
              variant="outlined"
              name="lastname"
              value={formData.lastname}
              onChange={handleInputChange}
            />
            <TextField
              sx={{ marginBlock: '10px' }}
              fullWidth
              label="Telefon*"
              variant="outlined"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
            />
            <TextField
              sx={{ marginBlock: '10px' }}
              fullWidth
              label="E-posta*"
              variant="outlined"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            <TextField
              sx={{ marginBlock: '10px' }}
              fullWidth
              label="Paket Adedi*"
              variant="outlined"
              name="inventory"
              type="number"
              value={formData.inventory}
              onChange={handleInputChange}
            />
            <FormControl fullWidth>
              <InputLabel
                style={{ color: '#C1C6C9', fontSize: 15 }}
                id="demo-simple-select-label"
              >
                Teslimat Tipi*
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={'Teslimat Tipi*'}
                name="deliveryType"
                value={formData.deliveryType}
                onChange={handleInputChange}
                sx={{
                  marginBottom: 2,
                  backgroundColor: '#ffffff',
                  borderColor: '#C1C6C9',
                  textAlign: 'left',
                }}
              >
                {mall &&
                  deliveryTypes.map((type) => (
                    <MenuItem key={type.type} value={type.type}>
                      {type.title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {formData.deliveryType === 'points' && (
              <>
                <FormControl fullWidth>
                  <InputLabel
                    style={{ color: '#C1C6C9', fontSize: 15 }}
                    id="demo-simple-select-label"
                  >
                    Nokta Tipi*
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={'Nokta Tipi*'}
                    name="selectedPointType"
                    value={selectedPointType}
                    onChange={handlePointTypeChange}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                      textAlign: 'left',
                    }}
                  >
                    {mall &&
                      pointsTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type === 'easypoint' ? 'Easy Point' : 'Lokasyon'}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                {/* İkinci Select Bileşeni */}
                {selectedPointType && (
                  <FormControl fullWidth>
                    <InputLabel
                      style={{ color: '#C1C6C9', fontSize: 15 }}
                      id="second-select-label"
                    >
                      {selectedPointType === 'easypoint'
                        ? 'Easy Point'
                        : 'Lokasyon'}
                      *
                    </InputLabel>
                    <Select
                      labelId="second-select-label"
                      id="second-select"
                      label={
                        selectedPointType === 'easypoint'
                          ? 'Easy Point'
                          : 'Lokasyon'
                      }
                      value={
                        selectedSubValue ? JSON.stringify(selectedSubValue) : ''
                      }
                      onChange={(e) =>
                        setSelectedSubValue(JSON.parse(e.target.value))
                      }
                      sx={{
                        marginBottom: 2,
                        backgroundColor: '#ffffff',
                        borderColor: '#C1C6C9',
                        textAlign: 'left',
                      }}
                    >
                      {mall.deliveryTypes.points
                        .filter((point) => point.type === selectedPointType)
                        .map((point) => (
                          <MenuItem
                            key={point.type}
                            value={JSON.stringify(point)}
                          >
                            {point.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
              </>
            )}
            {formData.deliveryType === 'address' && (
              <>
                <FormControl fullWidth>
                  <InputLabel
                    style={{ color: '#C1C6C9', fontSize: 15 }}
                    id="demo-simple-select-label"
                  >
                    Adres Tipi*
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={'Adres Tipi*'}
                    name="selectedAddressType"
                    value={selectedAddressType}
                    onChange={handlePredefinedTypeChange}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                      textAlign: 'left',
                    }}
                  >
                    {mall && predefinedTypes?.length > 0 && (
                      <MenuItem value={'predefined'}>
                        Ön Tanımlı Adres Seçiniz
                      </MenuItem>
                    )}
                    {mall && <MenuItem value={'address'}>Adres Gir</MenuItem>}
                  </Select>
                </FormControl>

                {selectedAddressType === 'address' && (
                  <>
                    <div
                      style={{
                        width: '100%',
                        flexDirection: 'row',
                        display: 'flex',
                        gap: '15px',
                      }}
                    >
                      <TextField
                        id="outlined-basic-4"
                        label={'Şehir'}
                        variant="outlined"
                        fullWidth
                        name="city"
                        value={mall.city}
                        disabled
                        InputLabelProps={{
                          style: { color: '#C1C6C9', fontSize: 15 },
                        }}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: '#ffffff',
                          borderColor: '#C1C6C9',
                        }}
                      />

                      <FormControl fullWidth>
                        <InputLabel
                          style={{ color: '#C1C6C9', fontSize: 15 }}
                          id="demo-simple-select-label"
                        >
                          İlçe*
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label={'İlçe*'}
                          name="selectedAddressType"
                          value={selectedTown}
                          disabled={townList?.length === 1}
                          onChange={handleChangeTown}
                          sx={{
                            marginBottom: 2,
                            backgroundColor: '#ffffff',
                            borderColor: '#C1C6C9',
                            textAlign: 'left',
                          }}
                        >
                          {mall &&
                            townList.map((town) => (
                              <MenuItem key={town} value={town}>
                                {town}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>

                    <FormControl fullWidth>
                      <InputLabel
                        style={{ color: '#C1C6C9', fontSize: 15 }}
                        id="demo-simple-select-label"
                      >
                        Mahalle*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label={'Mahalle*'}
                        name="selectedTown"
                        value={selectedDistrict}
                        disabled={!selectedTown}
                        onChange={(e) => setSelectedDistrict(e.target.value)}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: '#ffffff',
                          borderColor: '#C1C6C9',
                          textAlign: 'left',
                        }}
                      >
                        {mall &&
                          districtList?.map((district) => (
                            <MenuItem key={district} value={district}>
                              {district}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </>
                )}
              </>
            )}
            {selectedAddressType === 'predefined' && (
              <>
                <FormControl fullWidth>
                  <InputLabel
                    style={{ color: '#C1C6C9', fontSize: 15 }}
                    id="demo-simple-select-label"
                  >
                    Ön Tanımlı Adres Seçiniz*
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={'Ön Tanımlı Adres Seçiniz*'}
                    name="selectedPredefined"
                    value={selectedPredefined}
                    onChange={(e) => setSelectedPredefined(e.target.value)}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                      textAlign: 'left',
                    }}
                  >
                    {mall &&
                      mall.deliveryTypes.predefined.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                {selectedPredefined.type === 'hotel' && (
                  <TextField
                    id="outlined-basic-4"
                    label={`Oda No*`}
                    variant="outlined"
                    fullWidth
                    name="hotelRoom"
                    value={hotelRoom}
                    onChange={(e) => setHotelRoom(e.target.value)}
                    InputLabelProps={{
                      style: { color: '#C1C6C9', fontSize: 15 },
                    }}
                    sx={{
                      marginBottom: 5,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                    }}
                  />
                )}
              </>
            )}
            {formData.deliveryType === 'postbox' && (
              <>
                <FormControl fullWidth>
                  <InputLabel
                    style={{ color: '#C1C6C9', fontSize: 15 }}
                    id="demo-simple-select-label"
                  >
                    Dolap Lokasyonu*
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={'Dolap Lokasyonu*'}
                    name="selectedLockBox"
                    value={selectedLockBox}
                    onChange={(e) => setSelectedLockBox(e.target.value)}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                      textAlign: 'left',
                    }}
                  >
                    {mall &&
                      lockBoxList.map((lockBox) => (
                        <MenuItem key={lockBox.locationCode} value={lockBox}>
                          {lockBox.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </>
            )}
            {formData.deliveryType && (
              <>
                {selectedAddressType === 'address' && (
                  <TextField
                    id="outlined-multiline-1"
                    label={'Açık Adres Bilginizi Girin...'}
                    multiline
                    fullWidth
                    rows={4}
                    value={fullAddress}
                    onChange={(e) => setFullAddress(e.target.value)}
                    InputProps={{
                      style: {
                        height: 100,
                      },
                    }}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: '#ffffff',
                      borderColor: '#C1C6C9',
                    }}
                  />
                )}

                <TextField
                  id="outlined-multiline-2"
                  label={
                    selectedAddressType === 'address'
                      ? 'Adres Notu Giriniz'
                      : 'Not Giriniz'
                  }
                  multiline
                  fullWidth
                  value={addressDescription}
                  onChange={(e) => setAddressDescription(e.target.value)}
                  rows={4}
                  InputProps={{
                    style: {
                      height: 100,
                    },
                  }}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: '#ffffff',
                    borderColor: '#C1C6C9',
                  }}
                />
              </>
            )}

            <Button
              disabled={loading || isButtonDisabled()}
              onClick={() => createHandsfreeByStore()}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Tamamla'
              )}
            </Button>
          </Box>
        </Modal>

        <Modal
          open={rejectModal}
          onClose={() => {
            setRejectModal(false);
            setSelectedOrderID('');
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: 400,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography variant="h6">
              Müşterinin talebini reddetmek istediğinize emin misiniz?
            </Typography>

            <Button
              onClick={() => {
                rejectRequest();
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Evet'
              )}
            </Button>
          </Box>
        </Modal>

        <Dialog open={success}>
          <DialogTitle color={'green'}>Başarılı</DialogTitle>
          <DialogContent>
            <Typography>İşleminiz gerçekleştirildi.</Typography>
            <Stack direction="column" spacing={2} mt={2}>
              {orderNumbers?.map((orderNumber, index) => (
                <Box key={index} display="flex" alignItems="center">
                  <Typography>
                    {index + 1}) {orderNumber}
                  </Typography>
                </Box>
              ))}
              {note &&
                (() => {
                  const parts = note.split(' ');
                  if (parts.length >= 2 && parts[1].length > 0) {
                    return (
                      <Typography>
                        Alıcı: {parts[0]} {parts[1][0]}.
                      </Typography>
                    );
                  }
                  return <Typography>Alıcı: {parts[0]}</Typography>;
                })()}

              {userNote && userNote?.length > 0 && (
                <Typography>Müşteri Notu: {userNote}</Typography>
              )}

              <Box display="flex" alignItems="center" sx={{ width: 350 }}>
                <Checkbox
                  checked={isCheckboxChecked}
                  onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
                />
                {!isHotel ? (
                  <Typography>
                    Gönderi kodlarını ilgili paketlerin üzerine yazdım.
                  </Typography>
                ) : (
                  <Typography>
                    Gönderi kodlarını, müşteri adını ve oda numarasını ilgili
                    paketlerin üzerine yazdım.
                  </Typography>
                )}
              </Box>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={!isCheckboxChecked}
              onClick={() => {
                setSuccess(false);
                window.location.reload(false);
              }}
              color="primary"
            >
              Tamam
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={successCreated}>
          <DialogTitle color={'green'}>Başarılı</DialogTitle>
          <DialogContent>
            <Typography>İşleminiz gerçekleştirildi.</Typography>
            <Stack direction="column" spacing={2} mt={2}>
              {storeOrderNumbers?.map((orderNumber, index) => (
                <Box key={index} display="flex" alignItems="center">
                  <Typography>
                    {index + 1}) {orderNumber}
                  </Typography>
                </Box>
              ))}
              <Typography>{notForStore}</Typography>
              <Typography>Teslimat Kodu: {deliveryPassword}</Typography>
              <Box display="flex" alignItems="center" sx={{ width: 350 }}>
                <Checkbox
                  checked={isCheckboxChecked2}
                  onChange={() => setIsCheckboxChecked2(!isCheckboxChecked2)}
                />
                <Typography>
                  Gönderi kodlarını ilgili paketlerin üzerine yazdım.
                </Typography>
              </Box>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={!isCheckboxChecked2}
              onClick={() => {
                setSuccessCreated(false);
                window.location.reload(false);
              }}
              color="primary"
            >
              Tamam
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={failed} onClose={() => setFailed(false)}>
          <DialogTitle color={'red'}>Hata</DialogTitle>
          <DialogContent>
            <Typography>İşleminiz gerçekleştirilemedi.</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFailed(false)} color="primary">
              Kapat
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={rejectedSuccess}
          onClose={() => {
            window.location.reload(false);
            setRejectedSuccess(false);
          }}
        >
          <DialogTitle color={'green'}>Başarılı</DialogTitle>
          <DialogContent>
            <Typography>Talep reddedilmiştir.</Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                window.location.reload(false);
                setRejectedSuccess(false);
              }}
              color="primary"
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </>
  );
}
